import React from 'react'
import { Box, Typography } from "@mui/material"
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'



const Footer = () => {
  return (
    <footer>
        <Box sx={{textAlign: 'center', color: 'white', padding: '1rem', lineHeight: '3rem', backgroundColor: '#333'}}>
            <Typography sx={{fontWeight: 'bold', fontSize: '1.5rem'}}>
                Proantra
            </Typography>
            <Typography>
                &copy; {new Date().getFullYear()} Proantra. All rights reserved.
            </Typography>
{/*             <Typography>
                123 Main Street, City, State, USA
            </Typography> */}
{/*             <Typography>
                + 1  123  345  6789
            </Typography> */}
            <Typography>
                info@proantra.com
            </Typography>
            <Box sx={{marginTop: '1rem'}}>
                <a href = 'https://www.instagram.com' target = 'blank' rel = 'noopener noreferrer'>
                <InstagramIcon sx={{marginRight: '10px', color: 'white', transition: 'color 0.3s ease', '&:hover': {color: 'rgb(0, 0, 255)'}
                }}/>
                </a>

                <a href = 'https://www.facebook.com' target = 'blank' rel = 'noopener noreferrer'>
                <FacebookIcon sx={{marginRight: '10px', color: 'white', transition: 'color 0.3s ease', '&:hover': {color: 'rgb(0, 0, 255)'}
                }}/>
                </a>

                <a href = 'https://www.linkedin.com' target = 'blank' rel = 'noopener noreferrer'>
                <LinkedInIcon sx={{marginRight: '10px', color: 'white', transition: 'color 0.3s ease', '&:hover': {color: 'rgb(0, 0, 255)'}
                }}/>
                </a>
            </Box>
{/* 
            <Typography sx={{fontStyle: 'italic'}}>
                Powered by Proantra
            </Typography>

 */}



        </Box>

    </footer>
  )
}

export default Footer